"use client"

import { useEffect } from "react"

export const ChunkRecovery: React.FC = () => {
  useEffect(() => {
    const onRejection = (e: PromiseRejectionEvent) => {
      const reason = e.reason ? String(e.reason.message || e.reason) : ""
      if (
        reason.includes("ChunkLoadError") ||
        reason.includes("Loading chunk") ||
        reason.includes("ERR_CACHE_READ_FAILURE")
      ) {
        window.location.reload()
      }
    }

    const onError = (e: ErrorEvent) => {
      const msg = e?.message || ""
      if (
        msg.includes("ChunkLoadError") ||
        msg.includes("Loading chunk")
      ) {
        window.location.reload()
      }
    }

    window.addEventListener("unhandledrejection", onRejection)
    window.addEventListener("error", onError)
    return () => {
      window.removeEventListener("unhandledrejection", onRejection)
      window.removeEventListener("error", onError)
    }
  }, [])

  return null
} 